import React from "react";

const CTASection = ({ onSearchClick }) => (
  <section className="gf-cta gf-card" aria-labelledby="cta-heading">
    <h2 id="cta-heading" className="gf-cta__title">
      Start exploring GitHub talent
    </h2>
    <p className="gf-cta__text">
      Find GitHub developers, filter by skills and location, and inspect
      repositories with a dashboard built for discovery.
    </p>
    <button
      type="button"
      className="gf-btn gf-btn--primary gf-cta__btn"
      onClick={onSearchClick}
    >
      Search developers now
    </button>
  </section>
);

export default CTASection;
